module.exports = __webpack_public_path__ + "../resources/images/magnifying-glass-7175f5f6a72438e1fa75aa77b9ad6634.png";